var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldCheck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32a16 16 0 1116-16 16.018 16.018 0 01-16 16zm0-29.83A13.83 13.83 0 1029.83 16 13.845 13.845 0 0016 2.17z",
    fill: "#FFBC3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.232 10.704l-9.504 9.503a1.588 1.588 0 002.246 2.246l9.504-9.504a1.588 1.588 0 10-2.246-2.245z",
    fill: "#FFBC3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.521 17.273l5.18 5.18a1.588 1.588 0 102.246-2.245l-5.18-5.18a1.588 1.588 0 00-2.246 2.245z",
    fill: "#FFBC3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCheck);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/goldCheck.2b2e6fd6.svg";
export { MemoForwardRef as ReactComponent };